export const load = () => ({
	title: 'Storm Window Alternative for Old and Historic Homes',
	showTitle: true,
});
